// extracted by mini-css-extract-plugin
export default {"card":"F0-z","carouselContainer":"G0-z","carouselContent":"H0-z"};